
export default {
    data: () => ({
       
    }),
    created: function () {
    },
    methods : {
    }
};